"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var performance_tracker_1 = require("@reverbdotcom/commons/dist/performance_tracker");
var user_store_1 = require("./user_store");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var PERFORMANCE_SAMPLE = 0.1;
var PAGE_TYPE_HOME = 'home';
var PAGE_TYPE_FEED = 'feed';
var PAGE_TYPE_DASHBOARD = 'dashboard';
var PAGE_TYPE_OTHER = 'other';
var PAGE_PREFIXES = [
    'c',
    'item',
    'marketplace',
    'news',
    'p',
];
function normalizedPrefix(prefix) {
    if (!prefix) {
        return PAGE_TYPE_HOME;
    }
    if (PAGE_PREFIXES.includes(prefix)) {
        return prefix;
    }
    return PAGE_TYPE_OTHER;
}
function getPagePrefix(pathname) {
    var _a = pathname.split('/', 3), first = _a[1], second = _a[2];
    if (first === 'my') {
        return (second === PAGE_TYPE_FEED) ? PAGE_TYPE_FEED : PAGE_TYPE_DASHBOARD;
    }
    if (first && (first.length === 2 || /^\w\w-\w\w$/.test(first))) {
        // locale path prefix
        return normalizedPrefix(second);
    }
    return normalizedPrefix(first);
}
function trackTimings(pathname) {
    if (pathname === void 0) { pathname = window.location.pathname; }
    var _a = user_store_1.default.getState(), isBot = _a.isBot, deviceName = _a.deviceName;
    if (is_node_1.default || isBot) {
        return;
    }
    var page = getPagePrefix(pathname);
    if (page === PAGE_TYPE_OTHER) {
        return;
    }
    var tags = {
        deviceName: deviceName,
        page: page,
        app: 'reverb',
    };
    performance_tracker_1.sampleTimings(tags, PERFORMANCE_SAMPLE);
}
exports.trackTimings = trackTimings;
//# sourceMappingURL=track_timings.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/track_timings.js
// module id = oyDR
// module chunks = 20 21